import { __decorate } from "tslib";
import { TextField as FASTTextField } from '@microsoft/fast-components';
import { attr } from '@microsoft/fast-element';
import { foundationTextFieldStyles as styles } from './text-field.styles';
import { foundationTextFieldTemplate as template } from './text-field.template';
// TODO: Raise a PR against FAST to get autocomplete stuff in place
/**
 * @tagname %%prefix%%-text-field
 */
export class TextField extends FASTTextField {
    constructor() {
        super(...arguments);
        this.autocapitalize = 'off';
    }
    autocompleteChanged() {
        if (this.proxy instanceof HTMLInputElement) {
            this.proxy.autocomplete = this.autocomplete;
        }
    }
    autocapitalizeChanged() {
        if (this.proxy instanceof HTMLInputElement) {
            this.proxy.autocapitalize = this.autocapitalize;
        }
    }
}
__decorate([
    attr
], TextField.prototype, "autocomplete", void 0);
__decorate([
    attr
], TextField.prototype, "autocapitalize", void 0);
__decorate([
    attr
], TextField.prototype, "step", void 0);
// explicitly declaring for extensibility
export const foundationTextFieldShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
export const defaultTextFieldConfig = {};
/**
 * The Foundation Text Fields
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-text-field\>
 */
export const foundationTextField = TextField.compose(Object.assign({ baseName: 'text-field', template,
    styles, shadowOptions: foundationTextFieldShadowOptions }, defaultTextFieldConfig));
